const { get } = require('../../utils/objectHelpers');
const { ajax } = require('../../utils/ajaxHandler');

module.exports = {
    onCreate(input) {
        this.state = {
            keyword: '',
            suggestionListClassOpen: '',
            iconClass: '',
            inputClass: '',
            suggestions: [],
            placeHolderText: getPlaceholderText(input),
            isSticky: false
        };
        this.autoCompleteUrl = get(input, 'storeSearchField.autocomplete.action.URL', '');
        this.searchUrl = get(input, 'searchButtonWeb.action.URL', '');
    },
    onInput(input) {
        this.state.placeHolderText = getPlaceholderText(input);
    },
    onMount() {
        this.subscribeTo(document.body).on('click', (e) => {
            if (e.target.classList && !e.target.classList.contains('str-search__suggestions')) {
                this.closeSuggestionsList();
            }
        });
    },
    handleInput(e) {
        const searchTerm = e.target.value;
        this.state.keyword = searchTerm;
        if (searchTerm) {
            searchTerm.trim().toLowerCase();
            const requestObj = {
                method: 'GET',
                responseType: 'json',
                withCredentials: false,
                url: `${this.autoCompleteUrl}&kwd=${encodeURIComponent(searchTerm)}`
            };
            ajax(requestObj, { successCallBack: (data) => {
                this.onResponse(data);
            } });
        } else {
            this.closeSuggestionsList();
        }
    },
    updateInput(keyword) {
        this.state.keyword = keyword;
    },
    handleFocus() {
        this.state.iconClass = 'str-search__icon--hide';
        this.state.inputClass = 'str-search__input--focus';
    },
    toggleActive(e) {
        this.state.suggestions.forEach((suggestion) => {
            suggestion.active = e.target.closest('li')?.getAttribute('value') === suggestion.text;
        });
        this.setStateDirty('suggestions');
    },
    handleInputNav(e) {
        const focusedInput = document.querySelector('.str-search__input--focus');
        const searchResults = document.querySelector('.str-search__suggestions--open');

        if (searchResults) {
            if (focusedInput && e.key === 'ArrowDown') {
                e.preventDefault();
                searchResults.firstChild.focus();
            }
        }
    },
    handleResultsNav(e) {
        if (e.key === 'ArrowDown' && e.target.nextSibling) {
            e.preventDefault();
            e.target.blur();
            e.target.nextSibling.focus();
        } else if (e.key === 'ArrowUp' && e.target.previousSibling) {
            e.preventDefault();
            e.target.blur();
            e.target.previousSibling.focus();
        }

        if (e.key === 'Enter') {
            const selectedKeyword = e.target.getAttribute('value');
            this.updateInput(selectedKeyword);
            window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(selectedKeyword)}`;
        }

        if (e.key === 'Tab') {
            this.closeSuggestionsList();
        }
    },
    handleBlur() {
        if (!this.state.keyword) {
            this.state.iconClass = '';
            this.state.inputClass = '';
        }
    },
    onSubmit(e) {
        e.preventDefault();
        if (this.state.keyword) {
            const searchTerm = this.state.keyword.trim().toLowerCase();
            window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(searchTerm)}`;
        }
    },
    handleSuggestListSelect(e) {
        const selectedKeyword = e.target.closest('li')?.getAttribute('value');
        this.updateInput(selectedKeyword);
        window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(selectedKeyword)}`;
    },
    onResponse: function(response) {
        if (response && response.res && response.res.sug) {
            const suggestions = response.res.sug;
            this.state.suggestions = [];
            suggestions.forEach((suggestion, i) => {
                this.state.suggestions.push({ id: i, text: suggestion });
            });
        }
        if (this.state.suggestions && this.state.suggestions.length > 0) {
            this.setStateDirty('suggestions');
            this.state.suggestionListClassOpen = 'str-search__suggestions--open';
        }
    },
    closeSuggestionsList: function() {
        this.state.suggestions = [];
        this.setStateDirty('suggestions');
        this.state.suggestionListClassOpen = '';
    }
};

function getPlaceholderText(input) {
    return get(input, 'storeSearchField.placeHolder.textSpans.0.text', '');
}
